(function () {
  function applyPopupStyles() {
    var host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById('vs-popup-style-override')) return true;

    var style = document.createElement('style');
    style.id = 'vs-popup-style-override';
    style.textContent = `
      @media (min-width: 750px) {
        section[role="dialog"][aria-label] {
          margin-top: 18vh !important;
        }
      }
      @media (max-width: 749px) {
        section[role="dialog"][aria-label] {
          transform: scale(0.7) !important;
          transform-origin: center center !important;
        }
      }
    `;
    host.shadowRoot.appendChild(style);
    return true;
  }

  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    if (applyPopupStyles() || attempts > 40) clearInterval(timer);
  }, 500);
})();


(function () {
  var THRESHOLD = 0.20;
  var SELECTOR = '.squadkin-wrapper-container, whatsapp-chat-by-squadkin';
  var elements = [];

  function toggleVisibility() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrolledPercent = docHeight > 0 ? scrollTop / docHeight : 0;

    elements.forEach(function (el) {
      if (scrolledPercent >= THRESHOLD) {
        el.classList.add('ss-visible');
      } else {
        el.classList.remove('ss-visible');
      }
    });
  }

  function registerElement(el) {
    if (elements.indexOf(el) === -1) {
      elements.push(el);
      toggleVisibility();
    }
  }

  // Already-present elements
  document.querySelectorAll(SELECTOR).forEach(registerElement);

  // Elements jo baad me inject hote hain (async widget)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SELECTOR)) registerElement(node);
        if (node.querySelectorAll) {
          node.querySelectorAll(SELECTOR).forEach(registerElement);
        }
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('scroll', toggleVisibility, { passive: true });
})();